// Reveal homepage sections and article content as they enter the viewport.
(function () {
    if (!('IntersectionObserver' in window)) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var elements = document.querySelectorAll([
        '.home-template .edition-home > section',
        '[data-article-content] > *'
    ].join(', '));

    if (!elements.length) {
        return;
    }

    document.documentElement.classList.add('has-reveal-motion');

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function (element) {
        element.classList.add('northline-reveal');
        observer.observe(element);
    });
})();
